{
  "common": {
    "price": "Price",
    "open": "Open",
    "close": "Close",
    "high": "High",
    "low": "Low",
    "bid": "Bid",
    "ask": "Ask",
    "time": "Time",
    "date": "Date",
    "country": "Country",
    "name": "Name",
    "currency": "Currency",
    "yes": "Yes",
    "no": "No",
    "exchange": "Exchange",
    "type": "Type",
    "1month": "1 month",
    "3months": "3 months",
    "6months": "6 months",
    "1year": "1 year",
    "messages": {
      "nodata": "No data available",
      "error": "There was an error while getting the data. Please try reloading the page."
    },
    "currencies": {
      "USD": "US Dollar",
      "CAD": "Canadian Dollar"
    },
    "shortMonths": {
      "January": "Jan",
      "February": "Feb",
      "March": "Mar",
      "April": "Apr",
      "May": "May",
      "June": "Jun",
      "July": "Jul",
      "August": "Aug",
      "September": "Sep",
      "October": "Oct",
      "November": "Nov",
      "December": "Dec"
    },
    "buttons": {
      "D": "D",
      "2D": "2D",
      "W": "W",
      "2W": "2W",
      "M": "M",
      "3M": "3M",
      "YTD": "YTD",
      "Y": "Y",
      "2Y": "2Y",
      "10Y": "10Y",
      "max": "Max"
    },
    "buy": "Buy",
    "sell": "Sell"
  },
  "WMainIndex": {
    "chart": "Chart",
    "table": "Table",
    "trades": "Trades",
    "lastClose": "Last Close",
    "turnover": "Turnover",
    "tradedVolume": "Traded Volume",
    "marketTrend": "Market Trend",
    "1week": "1 week",
    "yearToDate": "Year to Date",
    "captions": {
      "trades": "Table showing the trades details",
      "trend": "Table showing the market trends"
    }
  },
  "WMarketList": {
    "header": {
      "ticker": "Ticker",
      "changePlusMinus": "+/-",
      "changePercentage": "%",
      "histClose": "Hist.Close",
      "sortable": "Sortable"
    },
    "messages": {
      "norics": "No data available for the given instrument(s)"
    }
  },
  "WMarketTiles": {
    "changePercentage": "Change %",
    "changeAbsolute": "Change abs.",
    "turnover": "Turnover",
    "messages": {
      "norics": "No data available.",
      "invalidInput": "Invalid input configuration. Please use the format like setRics([\" .GDAXI \"])"
    },
    "WTickerBand": {}
  },
  "WNewsHeadlines": {
    "placeholders": {
      "symbols": "Add Symbol",
      "topics": "Add Topic",
      "keywords": "Add Keyword"
    },
    "labels": {
      "headline": "Headline",
      "source": "Source",
      "keywords": "Keyword(s)",
      "symbols": "Symbol(s)",
      "topics": "Topic(s)"
    },
    "messages": {
      "nodata": "No headlines found.",
      "incompletedata": "Missing data to display the selected view."
    }
  },
  "WInterestRate": {
    "messages": {
      "paramsError": "The number of parameters provided for each column are not the same."
    }
  },
  "WInstrumentInfo": {
    "header": {
      "totvol": "Volume",
      "bidsize": "Bid Size",
      "asksize": "Ask Size",
      "roundlot": "Lot Size"
    }
  },
  "WPriceChart": {
    "controls": {
      "placeholder": "Compare with",
      "dateFrom": "From",
      "dateTo": "To"
    },
    "tooltip": {
      "price": "Price: {VALUE}",
      "volume": "Volume: {VALUE}"
    },
    "labels": {
      "shortDays": {
        "Sunday": "Sun",
        "Monday": "Mon",
        "Tuesday": "Tue",
        "Wednesday": "Wed",
        "Thursday": "Thu",
        "Friday": "Fri",
        "Saturday": "Sat"
      },
      "inputLabel": {
        "day": "Day",
        "month": "Month",
        "year": "Year"
      },
      "inputPlaceholder": {
        "day": "DD",
        "month": "MM",
        "year": "YYYY"
      }
    }
  },
  "WEstimatesRatios": {
    "analystConsensus": {
      "title": "Analyst Consensus",
      "strongsell": "Strong Sell",
      "hold": "Hold",
      "strongbuy": "Strong Buy",
      "targetTitle": "Difference to Target Price",
      "low": "52W Low",
      "high": "52W High",
      "tp": "TP",
      "recommendation": "Recommendation",
      "tpfull": "Target Price",
      "pltg": "Projected LT Growth"
    },
    "titles": {
      "companyInfo": "Company Information",
      "total": "Total",
      "valuationProfit": "Valuation & profitability",
      "forecast": "Forecast",
      "current": "Current",
      "perShareData": "Per Share Data"
    },
    "table": {
      "marketCap": "Market capitalization mn",
      "sharesOutstanding": "Shares outstanding",
      "commonshare": "Common Shareholders",
      "enterpriseValue": "Enterprise Value mn",
      "numberEmployees": "Number of Employees",
      "pe": "P/E Ratio",
      "ps": "P/S Ratio",
      "pb": "P/BV Ratio",
      "pcf": "P/CF Ratio",
      "peg": "PEG",
      "earningYield": "Earnings Yield",
      "dividendYield": "Dividend Yield",
      "revenue": "Revenue mn",
      "ebit": "EBIT mn",
      "netIncome": "Net Income mn",
      "gpm": "Gross Profit Margin",
      "roe": "Return on Equity",
      "eps": "Earnings per Share",
      "rps": "Revenues per Share",
      "bps": "Book Value per Share",
      "cfps": "Cash flow per Share",
      "cps": "Cash per Share",
      "dividendPerShare": "Dividend per share",
      "captions": {
        "companyInfo": "Table showing the company information",
        "valuationProfit": "Table showing the value and profitabiliy ratios",
        "perShareData": "Table showing the per share data",
        "total": "Table showing the total data"
      }
    }
  },
  "WCompanyProfile": {
    "titles": {
      "masterData": "Master Data",
      "clearingCodes": "Clearing Codes",
      "keyDates": "Key Dates",
      "activities": "Activities",
      "management": "Management"
    },
    "table": {
      "companyID": "Company ID",
      "parValue": "Par value",
      "sharesOutstanding": "Shares Outstanding",
      "marketCap": "Market Capitalization mn",
      "freeFloat": "Free Float in %",
      "employees": "Employees",
      "headquarters": "Company Headquarters",
      "phone": "Telephone",
      "fax": "Fax",
      "internet": "Internet",
      "isin": "ISIN",
      "valor": "Valor",
      "cusip": "CUSIP",
      "finYearEnd": "Fiscal year end",
      "reportingDateQ1": "Quarterly figures I",
      "reportingDateQ2": "Quarterly figures II",
      "reportingDateQ3": "Quarterly figures III",
      "reportingDateQ4": "Quarterly figures IV",
      "reportingDateA": "Prelim. year-end report",
      "captions": {
        "masterData": "Table showing the master data",
        "clearingCodes": "Table showing the clearing codes",
        "keyDates": "Table showing key dates",
        "activities": "Section showing activities",
        "management": "Table showing management details"
      }
    }
  },
  "WFundAllocation": {
    "types": {
      "HOLD": "HOLDINGS",
      "INVCNT": "COUNTRY",
      "ASSTALL": "ASSET ALLOCATION",
      "INDSECT": "INDUSTRY SECTOR",
      "DEBTQUAL": "DEBTOR QUALITY",
      "MATUR": "MATURITY"
    }
  },
  "WFundAvgAnnualReturns": {
    "tableHeaders": {
      "description": "Description",
      "3y": "3 Years",
      "5y": "5 Years",
      "10y": "10 Years",
      "ytd": "Year to Date",
      "inc": "Overall"
    },
    "lgcbenchmarkid": "Lipper Fund Classification"
  },
  "WPriceYieldChart": {
    "price": "Price",
    "yield": "Yield",
    "scaling": {
      "absolute": "Absolute",
      "percent": "Percent"
    },
    "chart": {
      "containerLabel": "This is a chart with Price or Yield data"
    }
  }
}
